import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
    flat: _ctx.flat,
    round: _ctx.rounded,
    class: "set-outline",
    type: _ctx.type,
    onClick: _ctx.onCancelClick,
    disable: _ctx.disable,
    loading: _ctx.loading,
    title: _ctx.title
  }, {
    loading: _withCtx(() => [
      (!_ctx.iconLeft && !_ctx.iconRight)
        ? (_openBlock(), _createBlock(_component_q_spinner, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_ctx.iconLeft)
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 1,
            class: "on-left"
          }))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_ctx.loadingLabel ?? _ctx.label ?? '') + " ", 1 /* TEXT */),
      (_ctx.iconRight)
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 2,
            class: "on-right"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    default: _withCtx(() => [
      (_ctx.iconLeft && !_ctx.iconRight)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            left: "",
            name: _ctx.iconLeft && !_ctx.loading ? _ctx.iconLeft : undefined
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, _toDisplayString(_ctx.label), 1 /* TEXT */),
      (_ctx.iconRight && !_ctx.iconLeft)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            right: "",
            name: _ctx.iconRight && !_ctx.loading ? _ctx.iconRight : undefined
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["flat", "round", "type", "onClick", "disable", "loading", "title"])), [
    [_directive_close_popup, _ctx.vClosePopup]
  ])
}